export const trailZerosAfterDecimal = (value: string | number): number => parseFloat(value.toString());

function shouldReturnNull(value, hideIfZero = true) {
    return isNaN(value) || (hideIfZero && trailZerosAfterDecimal(value) === 0);
}

export const defaultCurrencyFormat = (
    amount: number | string | null | undefined,
    languageCode: string,
    hideIfZero = true,
): string | null => {
    if (amount === undefined || amount == null || shouldReturnNull(amount, hideIfZero)) {
        return null;
    }
    return new Intl.NumberFormat(languageCode, {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    }).format(Number(amount));
};

export const defaultPercentFormat = (
    percentage: number | null | undefined,
    languageCode: string,
    hideIfZero = true,
): string | null => {
    if (percentage === undefined || percentage == null || shouldReturnNull(percentage, hideIfZero)) {
        return null;
    }
    return new Intl.NumberFormat(languageCode, {
        style: "percent",
        maximumFractionDigits: 2,
    }).format(Number(percentage) / 100);
};

export const defaultDecimalFormat = (
    decimal: number | null | undefined,
    languageCode: string,
    suffix?: string,
    minimumFractionDigits?: number,
    hideIfZero = true,
): string | null => {
    if (decimal === undefined || decimal == null || shouldReturnNull(decimal, hideIfZero)) {
        return null;
    }
    let options = {
        style: "decimal",
    } as Intl.NumberFormatOptions;

    if (minimumFractionDigits) {
        options = { ...options, minimumFractionDigits };
    }
    const formattedValue = new Intl.NumberFormat(languageCode, options).format(Number(decimal));
    return suffix ? `${formattedValue} ${suffix}` : formattedValue;
};
